import {
  GET_POLICY_DATA,
  GET_POLICY_DETAIL_DATA,
  GET_K2_REPORT_DATETIME_DATA,
  GET_K2_REPORT_GROUP_DATA,
  GET_K2_REPORT_INDIVIDUAL_DATA,
  GET_K2_REPORT_SUMMARY_DATA,
  SET_POLICY_DATA,
  SET_POLICY_DETAIL_DATA,
  SET_K2_REPORT_BREADCRUMB_DATA,
  SET_K2_REPORT_DATETIME_DATA,
  SET_K2_REPORT_SELECTED_BREADCRUMB_DATA,
  SET_K2_REPORT_SELECTED_TAB_DATA,
  SET_K2_REPORT_SUMMARY_DATA,
  SET_K2_REPORT_TABLE_DATA,
  SET_K2_REPORT_FILTER,
  CHECK_AGENT_IS_LEAF_NODE,
  GET_TEAM_POLICY_DATA,
  SET_TEAM_POLICY_DATA,
  RESET_POLICY_DATA,
  RESET_STATE,
  FETCH_POLICY_LIST_START,
  FETCH_POLICY_LIST_SUCCESS,
} from './constants.js';

const getK2ReportDatetimeDataAction = (payload) => ({
  type: GET_K2_REPORT_DATETIME_DATA,
  payload,
});

const setK2ReportDateTimeDataAction = (payload) => ({
  type: SET_K2_REPORT_DATETIME_DATA,
  payload,
});

const checkAgentIsLeafNodeAction = (payload, callback) => ({
  type: CHECK_AGENT_IS_LEAF_NODE,
  payload,
  callback,
});

const getK2ReportGroupDataAction = (payload) => ({
  type: GET_K2_REPORT_GROUP_DATA,
  payload,
});

const setK2ReportTableDataAction = (payload) => ({
  type: SET_K2_REPORT_TABLE_DATA,
  payload,
});

const getK2ReportIndividualDataAction = (payload) => ({
  type: GET_K2_REPORT_INDIVIDUAL_DATA,
  payload,
});

const setK2ReportSummaryDataAction = (payload) => ({
  type: SET_K2_REPORT_SUMMARY_DATA,
  payload,
});

const getK2ReportSummaryDataAction = (payload) => ({
  type: GET_K2_REPORT_SUMMARY_DATA,
  payload,
});

const setK2ReportBreadcrumbDataAction = (payload) => ({
  type: SET_K2_REPORT_BREADCRUMB_DATA,
  payload,
});

const setK2ReportSelectedBreadcrumbDataAction = (payload) => ({
  type: SET_K2_REPORT_SELECTED_BREADCRUMB_DATA,
  payload,
});

const setK2ReportSelectedTabDataAction = (payload) => ({
  type: SET_K2_REPORT_SELECTED_TAB_DATA,
  payload,
});

const setK2ReportConfigFilter = (payload) => ({
  type: SET_K2_REPORT_FILTER,
  payload,
});

const getPolicyAction = (payload) => ({
  type: GET_POLICY_DATA,
  payload,
});

const setPolicyAction = (payload) => ({
  type: SET_POLICY_DATA,
  payload,
});

const resetPolicyDataAction = () => ({
  type: RESET_POLICY_DATA,
});

const getPolicyDetailAction = (payload, callback) => ({
  type: GET_POLICY_DETAIL_DATA,
  payload,
  callback,
});

const setPolicyDetailAction = (payload) => ({
  type: SET_POLICY_DETAIL_DATA,
  payload,
});

const getTeamPolicyAction = (payload) => ({
  type: GET_TEAM_POLICY_DATA,
  payload,
});

const setTeamPolicyAction = (payload) => ({
  type: SET_TEAM_POLICY_DATA,
  payload,
});

const resetStateAction = () => ({
  type: RESET_STATE,
});

const fetchPolicyListStartAction = () => ({
  type: FETCH_POLICY_LIST_START,
});

const fetchPolicyListSuccessAction = () => ({
  type: FETCH_POLICY_LIST_SUCCESS,
});

export {
  setK2ReportConfigFilter,
  getK2ReportDatetimeDataAction,
  setK2ReportDateTimeDataAction,
  getK2ReportGroupDataAction,
  setK2ReportTableDataAction,
  getK2ReportIndividualDataAction,
  getK2ReportSummaryDataAction,
  setK2ReportSummaryDataAction,
  setK2ReportBreadcrumbDataAction,
  setK2ReportSelectedBreadcrumbDataAction,
  getPolicyAction,
  setPolicyAction,
  getPolicyDetailAction,
  setPolicyDetailAction,
  setK2ReportSelectedTabDataAction,
  checkAgentIsLeafNodeAction,
  getTeamPolicyAction,
  setTeamPolicyAction,
  resetPolicyDataAction,
  resetStateAction,
  fetchPolicyListStartAction,
  fetchPolicyListSuccessAction,
};
